<template>
    <b-col class="col-4 text-center" :class="content.active_line? 'line-right': ''" lg="3" md="12" :style="content.padding_top" cols="12" v-if="content">
        <img :src="srcImagen" alt="">
        <p class="mt-5" :class="content.class_titulo" v-html="content.titulo">  </p>
        <p class="subtitulo-col" v-html="content.subtitulo"> </p>
    </b-col>
</template>
<script>
    export default {
        name: 'Block',
        props: {
            content: Object
        },
        computed: {
            srcImagen() {
                let src = require('@/assets/images/' + this.content.imagen)
                return src
            }
        }
    }
</script>
<style scoped>
</style>